<script lang="ts">
    import {getCdnUrl} from "$lib/cdn";
    import {extractUrlBySize} from "$lib/utils";
    import Button from "../Elements/Button.svelte";
    import { locale } from '$lib/translations';

    export let section: Section;
    export let index: number;

</script>

<div class="bg-accent-500 text-base-100 py-24 sm:py-32" >
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl lg:mx-0">
            {#if index === 0}
                <h1 class="text-5xl font-bold tracking-tight sm:text-6xl font-display">{section.title}</h1>
            {:else}
                <h2 class="text-4xl font-bold tracking-tight sm:text-5xl font-display">{section.title}</h2>
            {/if}
            <p class="mt-6 text-lg leading-8 text-base-100">{section.description}</p>
        </div>
        <ul role="list"
            class="mx-auto mt-20 grid max-w-2xl gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none"
            class:grid-cols-2={section.blocks.length === 4}
            class:grid-cols-1={section.blocks.length !== 4}
            class:lg:grid-cols-4={section.blocks.length === 4}
            class:lg:grid-cols-3={section.blocks.length !== 4}
        >
            {#each section.blocks as block}
            <li>
                <img class="aspect-[3/2] w-full rounded-2xl object-cover"
                     src={getCdnUrl(extractUrlBySize(block.image.data, 'medium'))}
                     alt="">
                <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight">{block.title}</h3>
                <p class="text-base leading-7 text-gray-300">{block.description}</p>
                {#if block.linkTitle && (block.linkUrl || block.page?.data?.attributes?.slug)}
                    <div class="mt-4">
                        <Button title={block.linkTitle} url={block.linkUrl ?? `/${$locale}/${block.page.data.attributes.slug}`} type="secondary" />
                    </div>
                {/if}
            </li>
            {/each}
        </ul>
    </div>
</div>
